import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import { useEffect, useState } from "react";
import {
  paymentOptionDisplay,
  paymentStatusDisplay,
} from "../../lib/utils/promise";
import { formattedDate } from "../../lib/utils/fixdate";
import { Button, Dropdown, Modal, ModalBody } from "react-bootstrap";
import { makeRequest } from "../../lib/api/request";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SuperButton from "../SuperButton";
import { useAuthContext } from "../../lib/context/auth";

const PaymentsHistoryList = (props) => {
  let navigate = useNavigate();
  const { user } = useAuthContext();

  const {
    payments,
    extraPayments,
    promise,
    reload,
    showAffectedPayments,
    affectedPayments,
    defaultPM,
  } = props;
  const isManual = defaultPM.resourcetype === "Manual";
  const promiseNotDeleted = promise?.status !== "deleted";
  const [loaded, setLoaded] = useState(false);
  const [allPayments, setAllPayments] = useState([]);
  const [affectedBy, setAffectedBy] = useState(null);
  const [showManual, setShowManual] = useState(false);
  const [showMoveBack, setShowMoveBack] = useState(false);
  const [showAllocateByPayment, setShowAllocateByPayment] = useState(false);
  const [showRemovePayment, setShowRemovePayment] = useState(false);
  const [showLinkCoverage, setShowLinkCoverage] = useState(false);
  // target for manual payment
  const [currentManual, setCurrentManual] = useState({});
  const [currentMoveBack, setCurrentMoveBack] = useState({});
  const [currentAllocateByPayment, setCurrentAllocateByPayment] = useState({});
  const [currentRemovePayment, setCurrentRemovePayment] = useState({});
  const [coveredByPaymentId, setCoveredByPaymentId] = useState("");
  const [currentLinkCoveragePayment, setCurrentLinkCoveragePayment] = useState({});
  const [linkCoveragePaymentId, setLinkCoveragePaymentId] = useState("");
  const [currentError, setCurrentError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    let paymentsCombined = [
      ...payments.filter((p) => p.status !== "scheduled"),
      ...extraPayments,
    ]
      .sort((a, b) => {
        return new Date(a?.paymentDate) - new Date(b?.paymentDate);

        // if (a.paymentDate && b.paymentDate) {
        // return new Date(a?.paymentDate) > new Date(b?.paymentDate)
        // }

        // else if (a.scheduledPaymentDate && b.scheduledPaymentDate) {
        //   return new Date(a.scheduledPaymentDate) > new Date(b.scheduledPaymentDate)

        // } else if (a.scheduledPaymentDate && b.paymentDate) {
        //   return new Date(a.scheduledPaymentDate) > new Date(b.paymentDate)
        // } else if (a.paymentDate && b.scheduledPaymentDate) {
        //   return new Date(a.paymentDate) > new Date(b.scheduledPaymentDate)
        // }

        // return true
      })
      .reverse();

    setAllPayments(paymentsCombined);
  }, [payments, extraPayments]);

  const handleSetAffected = (newAfftectedBy, affectedIds) => {
    // console.log(affectedBy, newAfftectedBy, affectedBy === newAfftectedBy)
    if (affectedBy === newAfftectedBy) {
      showAffectedPayments([]);
      setAffectedBy(null);
    } else {
      showAffectedPayments(affectedIds);
      setAffectedBy(newAfftectedBy);
    }
  };

  const performManual = () => {
    setShowManual(false);
    makeRequest(`promises/payments/${currentManual.id}/manual/`, "POST").then(
      (response) => {
        if (response === 403) {
          navigate("/403");
        }
        reload();
      },
    );
  };

  const performMoveBack = () => {
    setShowMoveBack(false);
    const formattedDate = selectedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    makeRequest(`promises/payments/${currentMoveBack.id}/move_back/`, "POST", {
      scheduled_payment_date: formattedDate,
    }).then((response) => {
      if (response === 403) {
        navigate("/403");
      }
      reload();
    });
  };

  const performUncomplete = (payment) => {
    makeRequest(
      `promises/payments/${payment.id}/move/completed-to-scheduled/`,
      "POST",
    ).then((response) => {
      if (response === 403) {
        navigate("/403");
      }
      reload();
    });
  };

  const performSoftDelete = (payment) => {
    setCurrentError(null);

    makeRequest(
      `promises/payments/${payment.id}/move/soft-delete/`,
      "POST",
    )
      .then((response) => {
        if (response === 403) {
          navigate("/403");
          return;
        }
        reload();
      })
      .catch((error) => {
        setCurrentError({ errorMessage: error.message });
      });
  };

  const performAllocateByPayment = () => {
    setShowAllocateByPayment(false);
    makeRequest(
      `promises/payments/${currentAllocateByPayment.id}/move/failed-to-completed/`,
      "POST",
      {
        covered_by_payment_id: coveredByPaymentId,
      },
    ).then((response) => {
      if (response === 403) {
        navigate("/403");
      }
      reload();
    });
  };

  const showAllocateByPaymentModal = (payment) => {
    const firstCompletedPayment = allPayments.find(
      (item) => item.status === "completed" && item.id !== payment.id,
    );

    setCurrentAllocateByPayment(payment);
    setCoveredByPaymentId(firstCompletedPayment?.id || "");
    setShowAllocateByPayment(true);
  };

  const performRemovePayment = () => {
    setShowRemovePayment(false);
    setCurrentError(null);

    makeRequest(`promises/payments/${currentRemovePayment.id}/`, "DELETE")
      .then((response) => {
        if (response === 403) {
          navigate("/403");
          return;
        }
        if (response.success === false) {
          setCurrentError({ errorMessage: response.message });
          return;
        }
        reload();
      })
      .catch((error) => {
        setCurrentError({ errorMessage: error.message });
      });
  };

  const performUnlinkCoverage = (payment) => {
    setCurrentError(null);

    makeRequest(`promises/payments/${payment.id}/unlink_coverage/`, "POST")
      .then((response) => {
        if (response === 403) {
          navigate("/403");
          return;
        }
        if (response.success === false) {
          setCurrentError({ errorMessage: response.message });
          return;
        }
        showAffectedPayments([]);
        setAffectedBy(null);
        reload();
      })
      .catch((error) => {
        setCurrentError({ errorMessage: error.message });
      });
  };

  const performLinkCoverage = () => {
    setShowLinkCoverage(false);
    setCurrentError(null);

    makeRequest(
      `promises/payments/${currentLinkCoveragePayment.id}/link_coverage/`,
      "POST",
      {
        to_payment_id: linkCoveragePaymentId,
      },
    )
      .then((response) => {
        if (response === 403) {
          navigate("/403");
          return;
        }
        if (response.success === false) {
          setCurrentError({ errorMessage: response.message });
          return;
        }
        reload();
      })
      .catch((error) => {
        setCurrentError({ errorMessage: error.message });
      });
  };

  const showLinkCoverageModal = (payment) => {
    const firstCoveragePayment = payments.find(
      (item) => !item.isExtra && item.id !== payment.id,
    );

    setCurrentLinkCoveragePayment(payment);
    setLinkCoveragePaymentId(firstCoveragePayment?.id || "");
    setShowLinkCoverage(true);
  };

  const isRecentCompletedPayment = (payment) => {
    if (payment.status !== "completed" || !payment.scheduledPaymentDate)
      return false;

    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

    return new Date(payment.scheduledPaymentDate) >= threeMonthsAgo;
  };

  const completedPaymentOptions = allPayments.filter(
    (payment) => payment.status === "completed",
  );
  const linkCoveragePaymentOptions = payments.filter(
    (payment) => !payment.isExtra,
  );

  const getPaymentActions = (payment, isMissed) => {
    const actions = [];

    if (isRecentCompletedPayment(payment)) {
      actions.push({
        label: "Move To Scheduled",
        onClick: () => performUncomplete(payment),
      });
    }

    if (isMissed && !payment.isExtra) {
      actions.push({
        disabled: completedPaymentOptions.length === 0,
        label: "Allocate By Payment",
        onClick: () => showAllocateByPaymentModal(payment),
      });
    }

    if (payment.migrated) {
      actions.push({
        label: "Remove Imported Payment",
        onClick: () => {
          setCurrentRemovePayment(payment);
          setShowRemovePayment(true);
        },
      });
    }

    if (payment.isExtra && payment.extraPaymentTargets.length > 0) {
      actions.push({
        label: "Unlink Coverage",
        onClick: () => performUnlinkCoverage(payment),
      });
    }

    if (payment.isExtra) {
      actions.push({
        disabled: linkCoveragePaymentOptions.length === 0,
        label: "Link Coverage",
        onClick: () => showLinkCoverageModal(payment),
      });
    }

    if (payment.status !== "deleted") {
      actions.push({
        label: "Delete",
        onClick: () => performSoftDelete(payment),
      });
    }

    return actions;
  };

  return (
    <>
      {currentError && (
        <p>
          Error: <span>{currentError.errorMessage}</span>
        </p>
      )}
      <Table>
        <thead>
          <tr>
            <td>Payment ID</td>
            <td>Pn Ref</td>
            <td>Payment Date</td>
            <td>Scheduled Payment Date</td>
            <td>Amount Paid</td>
            <td>Payment Method</td>
            <td>Option</td>
            <td>Status</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            {/*<td>Repay</td>*/}
            {/*    TODO: add a button that shows errors?*/}
          </tr>
        </thead>
        <tbody>
          {allPayments.map((payment, index) => {
            let isAffected =
              affectedPayments && affectedPayments.includes(payment.id);
            const isMissed =
              payment.status === "missed" || payment.status === "failed";
            const paymentActions = getPaymentActions(payment, isMissed);
            const paymentIssues = payment.errors ?? [];
            return (
              <tr
                key={`all-payments-payment-${payment.id}`}
                className={isAffected ? "affected-payment" : ""}
              >
                <td>{payment.id}</td>
                <td>{payment.pnRef || payment.pn_ref || "—"}</td>
                <td>{formattedDate(payment.paymentDate)}</td>
                <td>
                  {!payment.isExtra &&
                    payment.scheduledPaymentDate &&
                    formattedDate(payment.scheduledPaymentDate)}
                  {payment.isExtra && (
                    <Badge bg={"secondary"} className={"ml-1"}>
                      extra
                    </Badge>
                  )}
                </td>
                {/*<td>${payment.amount}</td>*/}
                <td>${payment.actualAmount}</td>
                <td>{payment.paymentMethodDetails}</td>
                <td>
                  <Badge bg={"primary"}>
                  {paymentOptionDisplay(payment.option)}
                  </Badge>
                </td>
                <td>
                  {isManual ? (
                    <>
                      {isMissed &&
                      payment.paymentMethod === props.defaultPM.id ? (
                        <Badge bg={"danger"}>{"Check not received"}</Badge>
                      ) : (
                        paymentStatusDisplay(payment.status)
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {!isManual && paymentStatusDisplay(payment.status)}
                  {paymentIssues.length > 0 && (
                    <div className="mt-1 d-flex flex-wrap gap-1">
                      {paymentIssues.map((error) => (
                        <Badge
                          bg="secondary"
                          key={`payment-issue-${payment.id}-${error.id}`}
                          title={error.errorMessage}
                          style={{ whiteSpace: "normal", textAlign: "left" }}
                        >
                          {error.errorMessage}
                        </Badge>
                      ))}
                    </div>
                  )}
                </td>
                <td>
                  {payment.isExtra &&
                    payment.extraPaymentTargets.length > 0 && (
                      <Button
                        size={"sm"}
                        variant={
                          affectedBy === payment.id ? "primary" : "secondary"
                        }
                        onClick={() => {
                          handleSetAffected(
                            payment.id,
                            payment.extraPaymentTargets
                              .filter((t) => t.id)
                              .map((t) => t.id),
                          );
                        }}
                      >
                        Show Affected
                      </Button>
                    )}
                </td>

                <td>
                  {isManual && isMissed && promiseNotDeleted && (
                    <Button
                      className={"btn btn-primary"}
                      onClick={() => {
                        setCurrentManual(payment);
                        setShowManual(true);
                      }}
                    >
                      Allocate Check Or Wire
                    </Button>
                  )}
                </td>
                <td>
                  {isMissed && !payment.isExtra && promiseNotDeleted && (
                    <Button
                      className={"btn btn-primary"}
                      onClick={() => {
                        setCurrentMoveBack(payment);
                        setShowMoveBack(true);
                      }}
                    >
                      Move Back
                    </Button>
                  )}
                </td>
                <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                  {user?.isSuperuser && paymentActions.length > 0 && (
                    <Dropdown className="d-inline-block">
                      <Dropdown.Toggle size="sm" variant="primary">
                        ⋮
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {paymentActions.map((action) => (
                          <Dropdown.Item
                            disabled={action.disabled}
                            key={`payment-action-${payment.id}-${action.label}`}
                            onClick={action.onClick}
                          >
                            {action.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Modal show={showManual} onHide={() => setShowManual(false)}>
        <Modal.Header closeButton>Allocate Check or Wire Payment</Modal.Header>
        <ModalBody>
          Are you sure you want to allocate a check or wire for{" "}
          {currentManual.actualAmount}?
        </ModalBody>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowManual(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => performManual()}
            disabled={currentManual.status === "deleted"}
          >
            Allocate
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAllocateByPayment}
        onHide={() => setShowAllocateByPayment(false)}
      >
        <Modal.Header closeButton>Allocate By Payment</Modal.Header>
        <ModalBody>
          <div className="mb-3">
            Failed payment: {currentAllocateByPayment.id}
          </div>
          <div className="form-group">
            <label className="form-label">Covered by payment:</label>
            <select
              className="form-control"
              value={coveredByPaymentId}
              onChange={(event) => setCoveredByPaymentId(event.target.value)}
            >
              {completedPaymentOptions.map((payment) => (
                <option value={payment.id} key={`covered-by-${payment.id}`}>
                  {formattedDate(payment.paymentDate)} - ${payment.actualAmount}{" "}
                  - {payment.id}
                </option>
              ))}
            </select>
          </div>
        </ModalBody>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAllocateByPayment(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => performAllocateByPayment()}
            disabled={!coveredByPaymentId}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showRemovePayment}
        onHide={() => setShowRemovePayment(false)}
      >
        <Modal.Header closeButton>Remove Imported Payment</Modal.Header>
        <ModalBody>
          Are you sure you want to remove imported payment{" "}
          {currentRemovePayment.id}?
        </ModalBody>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowRemovePayment(false)}
          >
            Close
          </Button>
          <SuperButton
            variant="danger"
            onClick={() => performRemovePayment()}
            disabled={!currentRemovePayment.id}
          >
            Remove
          </SuperButton>
        </Modal.Footer>
      </Modal>
      <Modal show={showLinkCoverage} onHide={() => setShowLinkCoverage(false)}>
        <Modal.Header closeButton>Link Coverage</Modal.Header>
        <ModalBody>
          <div className="mb-3">
            Extra payment: {currentLinkCoveragePayment.id}
          </div>
          <div className="form-group">
            <label className="form-label">Payment to cover:</label>
            <select
              className="form-control"
              value={linkCoveragePaymentId}
              onChange={(event) => setLinkCoveragePaymentId(event.target.value)}
            >
              {linkCoveragePaymentOptions.map((payment) => (
                <option value={payment.id} key={`link-coverage-${payment.id}`}>
                  {formattedDate(payment.scheduledPaymentDate || payment.paymentDate)} - ${payment.actualAmount} - {payment.id}
                </option>
              ))}
            </select>
          </div>
        </ModalBody>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLinkCoverage(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => performLinkCoverage()}
            disabled={!linkCoveragePaymentId}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showMoveBack} onHide={() => setShowMoveBack(false)}>
        <Modal.Header closeButton>Move Back Payment</Modal.Header>
        <ModalBody>
          Are you sure you want to move back a payment of $
          {currentMoveBack.actualAmount}?
          <div className="mt-3">
            <div className="form-group">
              <label className="form-label">Select new payment date:</label>
            </div>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              minDate={new Date()}
              className="form-control"
            />
          </div>
        </ModalBody>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMoveBack(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => performMoveBack()}
            disabled={currentMoveBack.status === "deleted"}
          >
            Move Back
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentsHistoryList;
